import api from '@cidade360/core-lib/api';
import { usePromise } from '@cidade360/core-lib/hooks/use-promise';
import LoadingContainer from '@cidade360/ui-lib/base/loader/LoadingContainer';
import { Redirect } from 'react-router-dom';
import { getEnv } from '@cidade360/core-lib/env';

export default function () {
  const env = getEnv();
  const { isLoading } = usePromise(api.authSignout as any, {});
  return !isLoading ? (
    <Redirect to={env.HOME_URL || '/admin'} />
  ) : (
    <LoadingContainer />
  );
}
